import * as React from "react";
import { useAddToHomescreenPrompt } from "./useAddToHomescreenPrompt";
import "../../App.css";

const AddToHomescreenButton: React.FC = () => {
  const [promptable, promptToInstall, isInstalled] = useAddToHomescreenPrompt();

  return promptable && !isInstalled ? (
    <button onClick={promptToInstall}>INSTALL APP</button>
  ) : null;
};

export default AddToHomescreenButton;
